const apiBase = `https://www.dreamchimney.com/api`;

// Consolidated API endpoints
export const ApiEndpoints = {
    // Sleeves endpoints
    sleevesRecent: `${apiBase}/sleevery/recent`,
    sleeve: `${apiBase}/sleevery/sleeve`,
    sleeves: `${apiBase}/sleevery/sleeves`,
    sleevesByTag: `${apiBase}/sleevery/search/tag`,
    sleevesByUser: `${apiBase}/sleevery/user`,
    popularTags: `${apiBase}/sleevery/tags/popular`,
    popularSleeves: `${apiBase}/sleevery/sleeves/popular`,
    mostCommentsSleeves: `${apiBase}/sleevery/sleeves/comments`,
    randomSleeve: `${apiBase}/sleevery/random`,
    sleevesSearch: `${apiBase}/sleevery/search`,
    addSleeve: `${apiBase}/sleevery/add`,
    editSleeve: `${apiBase}/sleevery/edit`,
    sleevesTags: `${apiBase}/sleevery/sleeves/tags`,

    // Comments endpoints
    recentComments: `${apiBase}/sleevery/comments/recent`,
    sleeveComments: `${apiBase}/sleevery/comments`,
    postSleeveComment: `${apiBase}/sleevery/comment/add`,
};

export default ApiEndpoints;

